import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Landing.css";
import doctorImg from "../assets/doctor-female.jpg";
import { Stethoscope, Car } from "lucide-react";
import { Mail, ShieldCheck, FileText, LayoutDashboard } from "lucide-react";
import logo from "../assets/logo.png";

const scrollToServices = () => {
  const section = document.getElementById("services");
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Landing() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "FormiDoc | Plateforme Médicale";
  }, []);

  return (
    <div className="landing">

      {/* NAVBAR */}
      <header className="nav">
        <div className="brand">
            <img src={logo} alt="FormiDoc logo" className="logo-img" />
          </div>

        <div className="nav-actions">
         {/* <button className="nav-link" onClick={() => navigate("/login_admin")}>
            Admin
          </button>*/}
          <button className="nav-btn" onClick={() => navigate("/login")}>
            Connexion
          </button>
        </div>
      </header>

      {/* HERO */}
      <section className="hero">
      <div className="hero-left fade-up fade-delay-1">
      <div className="badge">
            Plateforme de gestion médicale
          </div>

          <h1>
            Votre partenaire <span>santé</span><br />
            et expertise médicale
          </h1>

          <p>
            Simplifiez la gestion de vos rendez-vous médicaux grâce à une
            solution moderne, sécurisée et conforme aux exigences réglementaires.
          </p>

          <div className="hero-buttons">
            <button
              className="primary-btn"
              onClick={() => navigate("/login")}
            >
              Commencer maintenant →
            </button>

            <button className="secondary-btn" onClick={scrollToServices}>
              En savoir plus
            </button>
          </div>
        </div>

        <div className="hero-right fade-up fade-delay-2">
        <img src={doctorImg} alt="Médecin professionnelle" />
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" className="services">
      <div className="services-container">

    <div className="services-header">
      <h2>Nos services</h2>
      <p>
        Deux pôles d'expertise pour répondre à vos besoins médicaux réglementaires.
      </p>
    </div>

    <div className="services-grid">

    <div className="service-card fade-up fade-delay-2">        <div className="icon-box green">
          <Stethoscope size={28} strokeWidth={2} />
        </div>

        <h3>Médecins agréés ARS</h3>

        <p>
          Expertise médicale pour les fonctions publiques et les administrations.
          Évaluation complète et certifiée.
        </p>

      
      </div>


      <div className="service-card fade-up fade-delay-3">        <div className="icon-box orange">
          <Car size={28} strokeWidth={2} />
        </div>

        <h3>Médecins agréés Permis de Conduire</h3>

        <p>
          Contrôle médical de l'aptitude à la conduite.
          Résultats rapides, fiables et conformes aux normes.
        </p>
      
      </div>

    </div>

  </div>
</section>

      {/* FOOTER */}
      <footer className="footer">

<div className="footer-grid">

  <div className="footer-col">
    <h4>FormiDoc</h4>
    <p>Solution professionnelle de gestion médicale.</p>
  </div>

  <div className="footer-col">
    <h4>Navigation</h4>

    <div className="footer-item">
      <LayoutDashboard size={16} />
      <span>Connexion</span>
    </div>

    <div className="footer-item">
      <LayoutDashboard size={16} />
      <span>Espace Admin</span>
    </div>
  </div>

  <div className="footer-col">
    <h4>Conformité</h4>

    <div className="footer-item">
      <ShieldCheck size={16} />
      <span>RGPD</span>
    </div>

    <div className="footer-item">
      <FileText size={16} />
      <span>Sécurité des données</span>
    </div>
  </div>

  <div className="footer-col">
    <h4>Contact</h4>

    <div className="footer-item">
      <Mail size={16} />
      <span> contact@formidoc.fr</span>
    </div>
  </div>
  
</div>

<div className="footer-bottom">
  © 2026 FormiDoc — Tous droits réservés
</div>

</footer>

    </div>
  );
}
